export default __webpack_public_path__ + "static/media/img-slider-scb-anywhere-2.92f8fb9a.png";